import PropTypes from 'prop-types';
import { css, keyframes } from '@emotion/react';

import { colors } from 'styles/theme';
import { setOpacity } from 'styles/utils';

const spin = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

const positionCss = center => css`
  position: ${center ? 'absolute' : 'relative'};
  margin: auto;

  ${center &&
  css`
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `}
`;

const circularProgressCss = (size, color) => {
  const width = size / 6;

  return css`
    border-radius: 50%;
    display: block;
    width: ${size}em;
    height: ${size}em;
    border-top: ${width}em solid ${setOpacity(colors[color], 0.2)};
    border-right: ${width}em solid ${setOpacity(colors[color], 0.2)};
    border-bottom: ${width}em solid ${setOpacity(colors[color], 0.2)};
    border-left: ${width}em solid ${colors[color]};
    animation: ${spin} 1.1s infinite linear;
  `;
};

/**
 * @param {object} props
 */
function CircularProgress({
  className,
  size = 2,
  color = 'purple',
  center = false,
}) {
  return (
    <span css={positionCss(center)}>
      <span css={circularProgressCss(size, color)} className={className} />
    </span>
  );
}

CircularProgress.propTypes = {
  className: PropTypes.string,
  /** Progress size (in `em` units) */
  size: PropTypes.number,
  /** Progress color */
  color: PropTypes.oneOf([
    'pale',
    'purple',
    'darkPurple',
    'brightYellow',
    'sunYellow',
    'white',
  ]),
  /** Center the progress bar (the parent must have `position` defined) */
  center: PropTypes.bool,
};

export default CircularProgress;
